export enum DocumentType {
  CONSENT_DOC = 'ConsentDoc',
  CONSENT_TEXT = 'ConsentText',
  COOKIE_TEXT = 'CookieText',
  GDPR_POLICY = 'GdprPolicy',
  AGREEMENT_DOC = 'AgreementDoc',
  LOYALTY_TEXT = 'LoyaltyText',
  UNREGISTERED_CONSENT_TEXT = 'UnregisteredConsentText',
  ABROAD_DATA_SHARING_CONSENT = 'AbroadDataSharingConsent',
}
